import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationService {

  private readonly defaultConfig: Partial<IndividualConfig> = {
    timeOut: 3000,
    closeButton: true,
    progressBar: true,
    progressAnimation: 'increasing'
  };

  constructor(private toastr: ToastrService) {}

  /** Generic toast handler */
  private showToast(
    type: 'success' | 'error' | 'warning' | 'info',
    message: string,
    title?: string
  ): void {
    this.toastr[type](message, title, this.defaultConfig);
  }

  showSuccess(message: string, title?: string): void {
    this.showToast('success', message, title);
  }

  showError(message: string, title?: string): void {
    this.showToast('error', message, title);
  }

  showWarning(message: string, title?: string): void {
    this.showToast('warning', message, title);
  }

  showInfo(message: string, title?: string): void {
    this.showToast('info', message, title);
  }
}
